import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBug: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBug"><Path d="M7.5 7.5V7C7.5 4.51472 9.51472 2.5 12 2.5C14.4853 2.5 16.5 4.51472 16.5 7V7.5M2.5 13.5H5.5M18.5 13.5H21.5M5.25 9L2.75 8M5.5 18L2.75 19M18.75 9L21.25 8M18.5 18L21.25 19M12 13.5V21M5.5 7.5V15C5.5 18.5899 8.41015 21.5 12 21.5C15.5899 21.5 18.5 18.5899 18.5 15V7.5H5.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBug;
